import {Routes} from '@angular/router';
import {provideTranslocoScope} from '@jsverse/transloco';
import {authGuard} from './guards/auth.guard';
import {bookingEntryRedirect, bookingFlowGuard} from './guards/booking-flow.guard';
import {directBookingEntryParametersChildGuard} from './guards/direct-booking-entry-parameters.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: bookingEntryRedirect,
  },
  {
    path: 'dashboard/orders/:orderId/parcels',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/dashboard-parcels/dashboard-parcels').then((m) => m.DashboardParcels),
    providers: [...provideTranslocoScope('dashboard')],
  },
  {
    path: 'dashboard/orders/:orderId',
    canActivate: [authGuard],
    loadComponent: () => import('./components/dashboard/dashboard').then((m) => m.Dashboard),
    providers: [...provideTranslocoScope('dashboard')],
  },
  {
    path: 'components',
    loadComponent: () =>
      import('./components/external-component-testing/external-component-testing').then(
        (m) => m.ExternalComponentTesting,
      ),
  },
  {
    path: 'verify',
    loadComponent: () => import('./components/verify/verify').then((m) => m.Verify),
    providers: [
      ...provideTranslocoScope('booking-verify'),
      ...provideTranslocoScope('booking-common'),
    ],
  },
  {
    path: 'comeback/:id',
    loadComponent: () => import('./components/comeback/comeback').then((m) => m.Comeback),
    providers: [
      ...provideTranslocoScope('booking-comeback'),
      ...provideTranslocoScope('booking-common'),
    ],
  },
  {
    path: '',
    canActivateChild: [directBookingEntryParametersChildGuard, bookingFlowGuard],
    loadComponent: () =>
      import('./components/booking-stepper-layout/booking-stepper-layout').then(
        (m) => m.BookingStepperLayout,
      ),
    providers: [
      ...provideTranslocoScope('booking-stepper'),
      ...provideTranslocoScope('booking-common'),
    ],
    children: [
      {
        path: 'select-property',
        loadComponent: () =>
          import('./components/select-property/select-property').then((m) => m.SelectProperty),
        data: {bookingStep: 1},
        providers: [...provideTranslocoScope('booking-select-property')],
      },
      {
        path: 'service-provider',
        loadComponent: () =>
          import('./components/service-provider/service-provider').then((m) => m.ServiceProvider),
        data: {bookingStep: 2},
        providers: [...provideTranslocoScope('booking-service-provider')],
      },
      {
        path: 'property-owner',
        loadComponent: () =>
          import('./components/property-owner/property-owner').then((m) => m.PropertyOwner),
        data: {bookingStep: 3},
        providers: [...provideTranslocoScope('booking-property-owner')],
      },
      {
        path: 'power-of-attorney',
        loadComponent: () =>
          import('./components/power-of-attorney/power-of-attorney').then((m) => m.PowerOfAttorney),
        data: {bookingStep: 4, powerOfAttorneyMode: 'authority'},
        providers: [
          ...provideTranslocoScope('booking-poa-owner-to-provider'),
          ...provideTranslocoScope('booking-inheritance'),
        ],
      },
      {
        path: 'provider-power-of-attorney',
        loadComponent: () =>
          import('./components/provider-power-of-attorney/provider-power-of-attorney').then(
            (m) => m.ProviderPowerOfAttorney,
          ),
        data: {bookingStep: 5},
        providers: [...provideTranslocoScope('booking-poa-provider-to-docestate')],
      },
      {
        path: 'inheritance-documents',
        loadComponent: () =>
          import('./components/power-of-attorney/power-of-attorney').then((m) => m.PowerOfAttorney),
        data: {bookingStep: 6, powerOfAttorneyMode: 'inheritance'},
        providers: [
          ...provideTranslocoScope('booking-poa-owner-to-provider'),
          ...provideTranslocoScope('booking-inheritance'),
        ],
      },
      {
        path: 'checkout',
        loadComponent: () => import('./components/checkout/checkout').then((m) => m.Checkout),
        data: {bookingStep: 'review'},
        providers: [
          ...provideTranslocoScope('booking-checkout'),
          ...provideTranslocoScope('booking-select-property'),
          ...provideTranslocoScope('booking-property-owner'),
          ...provideTranslocoScope('booking-service-provider'),
        ],
      },
      {
        path: 'order-confirmation/:orderId',
        loadComponent: () =>
          import('./components/order-confirmation/order-confirmation').then(
            (m) => m.OrderConfirmation,
          ),
        data: {bookingStep: 'review', completedBookingStep: true, disableStepSelection: true},
        providers: [...provideTranslocoScope('booking-confirmation')],
      },
    ],
  },
  {
    path: 'invoice-checkout',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/invoice-checkout/invoice-checkout').then((m) => m.InvoiceCheckout),
    providers: [...provideTranslocoScope('invoice-checkout')],
  },
  {
    path: 'invoice-confirmation',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/invoice-confirmation/invoice-confirmation').then(
        (m) => m.InvoiceConfirmation,
      ),
    providers: [...provideTranslocoScope('invoice-confirmation')],
  },
  {
    path: 'signature',
    loadComponent: () => import('./components/signature/signature').then((m) => m.Signature),
    canActivate: [authGuard],
  },
];
